module.exports = __webpack_public_path__ + "img/closebotton.ee773207.png";